import type { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import type { ReactElement } from 'react';

import { SvgIcon } from '@mui/material';

type Props = SvgIconProps & {
  children?: ReactElement<SVGLinearGradientElement>;
  size?: number | string;
};
export const RoundCornerSquareIcon = ({
  children,
  size = 24,
  ...props
}: Props) => (
  <SvgIcon {...props} style={{ fontSize: size }} viewBox="0 0 24 24">
    {children && <defs>{children}</defs>}
    <path
      {...(children ? { fill: `url(#${children.props.id})` } : {})}
      d="M12.01,24a43.531,43.531,0,0,1-7.933-.759A4.172,4.172,0,0,1,.734,19.9a42.975,42.975,0,0,1,0-15.822A4.172,4.172,0,0,1,4.077.734h0A43,43,0,0,1,19.9.734a4.172,4.172,0,0,1,3.342,3.342,42.975,42.975,0,0,1,0,15.822A4.172,4.172,0,0,1,19.9,23.24,39.128,39.128,0,0,1,12.015,24Z"
    />
  </SvgIcon>
);
